import Book from '../../objects/Book';
import Media from '../../objects/Media';
import SheetMusic from '../../objects/SheetMusic';

export const saveCart = (prod) => {

   if (localStorage.getItem('cart')) {
      localStorage.setItem('cart', `${localStorage.getItem('cart')},.,.${JSON.stringify(prod)}`);
   }
   else {
      localStorage.setItem('cart', JSON.stringify(prod));
   }
}

export const getCart = () => {
   let objStr = [];
   if(localStorage.getItem('cart')) {
      objStr = localStorage.getItem('cart').split(',.,.');
      objStr = objStr.map(val => {
         return JSON.parse(val);
      });
   }
   return objStr;
}

export const clearLocalStorage = () => {
   localStorage.clear();
}